import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomStore, ArkUnitOfWork, BreezeDxStoreService, AuthService, AppInformationService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BatchEditDialogComponent } from '../batch-edit-dialog/batch-edit-dialog.component';
import { Router } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import _ from 'lodash';
import moment from 'moment';

@Component({
    selector: 'app-reconciliation-search',
    templateUrl: './reconciliation-search.component.html',
    styleUrls: ['./reconciliation-search.component.scss'],
    standalone: false,
})
export class ReconciliationSearchComponent implements OnInit {
    batches: any[] = [];
    reviewOnly = false;
    generalFund: any[] = [];
    dataSource: any[] = [];
    selectedAmount: number;

    filter: any;
    canSeePledges: boolean = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private router: Router,
        private auth: AuthService,
        private modalService: BsModalService,
        public appInfo: AppInformationService
    ) {}

    async ngOnInit() {
        this.filter = {};
        this.reviewOnly = this.appInfo.graafschap && this.auth.hasRole('Secretary');
        this.canSeePledges = this.auth.hasRole('PledgesAdmin')
        const start = moment(new Date()).add(-3,'years').toDate();
        const end = new Date();
        this.appInfo.pleaseWaitShow();
        this.batches = await this.uow.getReconciliationData(start, end, this.canSeePledges);
        this.appInfo.pleaseWaitHide();

    }

    onSelectionChanged(e) {
        const rows = this.dataGrid.instance.getSelectedRowsData();
        this.selectedAmount = 0;
        rows.forEach(row => {
            this.selectedAmount += row.amount;
        });
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            // {
            //     widget: 'dxButton',
            //     options: {
            //         icon: 'revert',
            //         elementAttr: { title: 'Reset Filters' },
            //         onClick: () => {
            //             e.component.clearFilter();
            //         },
            //     },
            //     location: 'after',
            // },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    // add() {
    //     const modalRef = this.modalService.show(BatchEditDialogComponent, {
    //         class: 'modal-md',
    //         ignoreBackdropClick: true,
    //         keyboard: false,
    //         initialState: { routerOption: 'new' },
    //     });

    //     modalRef.content.result.subscribe(async (result) => {
    //         if (result.result) {
    //             this.open(result.batchId);
    //             this.dataGrid.instance.refresh();
    //         }
    //     });
    // }

    // async open(batchId: number) {
    //     if (!batchId) return;
    //     if (batchId) this.router.navigate(['/giving/batches/' + batchId]);
    // }
}
